import { render, staticRenderFns } from "./ProspectDashboard.vue?vue&type=template&id=015591ed&scoped=true&"
import script from "./ProspectDashboard.vue?vue&type=script&lang=js&"
export * from "./ProspectDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ProspectDashboard.vue?vue&type=style&index=0&id=015591ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015591ed",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
